import {useCallback, useEffect} from 'react';

/**
 * 이벤트 발생될 때 element가 있는지 확인하고 수행하는 이벤트 리스너를 window에 추가하는 훅입니다.
 */
export function useAddWindowEventListener<K extends keyof WindowEventMap>({
  element,
  type,
  listener,
}: {
  element?: HTMLElement | null;
  type: K;
  listener: (event: WindowEventMap[K]) => any;
}) {
  const handler = useCallback(
    (event: any) => {
      if (!element) {
        return listener(event);
      } else if (event.composedPath().includes(element)) {
        return listener(event);
      }
    },
    [element, listener]
  );

  useEffect(() => {
    window.addEventListener(type, handler);
    return () => {
      window.removeEventListener(type, handler);
    };
  }, [handler, type]);
}
